import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field, withFormik } from 'formik';
import axios from 'axios';
import * as yup from 'yup';
import { Ellipsis } from 'react-spinners-css';

import ProfileInput from '../../../form/ProfileInput';
import ProfileDatePickerInput from '../../../form/ProfileDatePickerInput';

const mapPropsToValues = props => {
  return {
    name: props.user.name,
    email: props.user.login,
    birthDate: props.user.birthDate ? new Date(props.user.birthDate) : null,
    phone: props.user.phone || '',
  };
};

const validationSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup
    .string()
    .email()
    .required(),
  birthDate: yup.date(),
  phone: yup.string().required(),
});

const handleSubmit = async (values, bag) => {
  bag.setSubmitting(true);

  bag.props.onStatusChanged({ isPending: true });

  try {
    await axios.put('/api/v1/profile/update-settings', values, {
      headers: {
        Authorization: `Bearer ${bag.props.token}`,
      },
    });

    bag.props.onStatusChanged({ isSuccess: true, message: 'Profile has been successfully updated' });
  } catch (e) {
    bag.props.onStatusChanged({ isError: true, message: 'Unknown server error' });
  }

  bag.setSubmitting(false);
};

const ProfileSettingsForm = props => {
  return (
    <Form noValidate className={props.className}>
      <Field
        name="name"
        label="Full name"
        isMobile={props.isMobile}
        component={ProfileInput}
        disabled={props.isSubmitting}
      />
      <Field name="email" label="Email" isMobile={props.isMobile} component={ProfileInput} disabled />
      <Field
        name="birthDate"
        label="Date of birth"
        isMobile={props.isMobile}
        component={ProfileDatePickerInput}
        disabled={props.isSubmitting}
      />
      <Field
        name="phone"
        label="Phone"
        isMobile={props.isMobile}
        component={ProfileInput}
        disabled={props.isSubmitting}
      />
      <button
        type="submit"
        className="gradient-button mt-10px"
        disabled={props.isSubmitting}
        style={{ width: '150px' }}
      >
        {!props.isSubmitting && <span>Save changes</span>}
        {props.isSubmitting && <Ellipsis color="white" size={40} />}
      </button>
    </Form>
  );
};

ProfileSettingsForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    login: PropTypes.string.isRequired,
    birthDate: PropTypes.any,
    phone: PropTypes.string,
  }).isRequired,
  onStatusChanged: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
};

export default withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit,
})(ProfileSettingsForm);
